import * as moment from 'moment';

import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { messages as i18n } from '@teem/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import * as Api from '@teem/constants/api';


export default class SettlementsTableSchema {
	keyColumn: string = 'uuid';
	userInfo: any = (window as any).userInfo;
	serverUrl: string = `${Api.settlements.all}`;
	containerContext: any;
	headers: Array<object> = [
		{ "label": $localize`:@@ts.payment_ref_id:Payment Ref/ID`, "thClass": "th-number" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
		{ "label": $localize`:@@ts.amount:Transferred Amount`, "thClass": "th-amountReceived" },
		{ "label": $localize`:@@ts.number_transactions:Number Of Transactions`, "thClass": "th-amountReceived" },
		{ "label": "", "thClass": "th-editdelete" }
	];
	cols: Array<object> = [
		{
			"key": "reference",
			"tdClass": "td-number",
			"render": (value, row) => {
				let t = value ? value : i18n.na;
				return `<span title="${t}">${t}</span>`;
			}
		},
		{
			"key": "created_at",
			"tdClass": "td-date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (`
						<div class="date">
							<span class="day">${d.format('DD')}</span>
							<span class="month">${d.format('MMM')}</span>
							<span class="year">${d.format('YYYY')}</span>
						</div>`
					);
				}
				return '';
			}
		},
		{
			"key": "amount",
			"tdClass": "td-amount",
			"render": (value) => {
				let currency = this.userInfo?.currency_symbol;
				return `<div class="amount">
                            <span class="price">${value ? value : 0}</span>
                            <span class="sar">${currency}</span>
                        </div>`
			}
		},
		{
			"key": "transactions",
			"tdClass": "td-amount", 
			"render": (value) => `${value}`
		},
		{
			"key": "",
			"tdClass": "td-editdelete"
		}
	];

	constructor(container: any) {
		this.containerContext = container;
	}
}
